module.exports = __webpack_public_path__ + "img/sv10.f941a1b7.svg";